
import { Card } from "@/components/ui/card";
import { useEffect } from "react";
import HeavenlyLoader from "@/components/HeavenlyLoader";
import HeroSection from "@/components/AtheismDefense/HeroSection";
import QuestionForm from "@/components/AtheismDefense/QuestionForm";
import { useAtheismDefense } from "@/components/AtheismDefense/useAtheismDefense";
import ResponseDisplay from "@/components/AtheismDefense/ResponseDisplay";
import SampleQuestions from "@/components/AtheismDefense/SampleQuestions";
import { useScrollToNewContent } from "@/hooks/useScrollToNewContent";

// Sample questions that users commonly ask
const sampleQuestions = [
  "Is there any real evidence that God exists?",
  "Why should I believe the Bible over science?",
  "How can you say there's absolute truth?",
  "Doesn't evolution disprove the Bible?",
  "Isn't morality just subjective?",
  "Why is Christianity better than humanism?"
];

const AtheismTool = () => {
  const {
    question,
    setQuestion,
    isLoading,
    isSaving,
    response,
    error,
    handleSubmit,
    handleSampleQuestion,
    saveResponse,
    shareViaEmail,
    shareViaSMS,
    shareToFacebook
  } = useAtheismDefense();

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  // Use hook to scroll to response when it's generated
  const responseRef = useScrollToNewContent(response, {
    behavior: "smooth",
    delay: 300,
    condition: !isLoading && !!response,
    offset: 100
  });

  return (
    <div className="max-w-6xl mx-auto">
      {/* Hero Section */}
      <HeroSection />

      {/* Sample Questions - Moved above the question form */}
      <SampleQuestions
        sampleQuestions={sampleQuestions}
        handleSampleQuestion={handleSampleQuestion}
      />

      {/* Question Form */}
      <QuestionForm
        question={question}
        setQuestion={setQuestion}
        handleSubmit={handleSubmit}
        isLoading={isLoading}
      />

      {/* Loading State */}
      {isLoading && <HeavenlyLoader message="Examining biblical responses to atheist arguments..." />}

      {/* Error Display */}
      {error && (
        <Card className="border-red-300 bg-red-50 p-4 mb-6">
          <p className="text-red-800">{error}</p>
        </Card>
      )}

      {/* Response Display */}
      {response && !isLoading && (
        <div ref={responseRef}>
          <ResponseDisplay 
            response={response}
            isSaving={isSaving}
            onSave={saveResponse}
            onShareEmail={shareViaEmail}
            onShareSMS={shareViaSMS}
            onShareFacebook={shareToFacebook}
          />
        </div>
      )}
    </div>
  );
};

export default AtheismTool;
